(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["marquee-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function fillMarqueeTrack(track) {
      const marquee = track.closest('[data-mab-marquee]');
      const root = track.closest('[data-marquee-announcement]');
      const template = track.querySelector('[data-mab-group]');
      if (!marquee || !template || !root) return false;

      root.classList.remove('mab--ready');
      track.style.animation = 'none';

      track.querySelectorAll('[data-mab-group]').forEach(function (group, index) {
        if (index > 0) group.remove();
      });

      const viewport = marquee.clientWidth || window.innerWidth;
      let group = track.querySelector('[data-mab-group]');
      if (!group) return false;

      let groupWidth = group.getBoundingClientRect().width;
      if (groupWidth <= 0) return false;

      const minTrackWidth = viewport * 2;
      let copies = 2;

      while (copies * groupWidth < minTrackWidth) {
        copies += 1;
      }

      if (copies % 2 !== 0) {
        copies += 1;
      }

      for (let i = 1; i < copies; i += 1) {
        track.appendChild(group.cloneNode(true));
      }

      const trackWidth = track.getBoundingClientRect().width;
      const loopDistance = trackWidth / 2;
      const speedSetting = parseFloat(getComputedStyle(root).getPropertyValue('--mab-speed')) || 35;
      const referenceLoop = 2000;
      const duration = (loopDistance / referenceLoop) * speedSetting;

      track.style.setProperty('--mab-scroll-distance', '-' + loopDistance + 'px');
      track.style.setProperty('--mab-speed-active', Math.max(5, duration) + 's');
      track.style.removeProperty('animation');
      root.classList.add('mab--ready');

      return true;
    }

    function initMarqueeAnnouncement(root) {
      const tracks = root.querySelectorAll('[data-mab-track]');
      let ready = true;

      tracks.forEach(function (track) {
        if (!fillMarqueeTrack(track)) ready = false;
      });

      return ready;
    }

    function initAll() {
      let allReady = true;

      document.querySelectorAll('[data-marquee-announcement]').forEach(function (root) {
        if (!initMarqueeAnnouncement(root)) allReady = false;
      });

      return allReady;
    }

    function initWithRetries(attempts) {
      attempts = attempts || 0;
      const ready = initAll();

      if (!ready && attempts < 20) {
        requestAnimationFrame(function () {
          initWithRetries(attempts + 1);
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initWithRetries();
      });
    } else {
      initWithRetries();
    }

    window.addEventListener('load', initAll);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(initAll);
    }

    document.addEventListener('shopify:section:load', function (event) {
      const root = event.target.querySelector('[data-marquee-announcement]');
      if (root) initWithRetries();
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(initAll, 150);
    });

    if (typeof ResizeObserver !== 'undefined') {
      var groupResizeTimer;
      var groupObserver = new ResizeObserver(function () {
        clearTimeout(groupResizeTimer);
        groupResizeTimer = setTimeout(initAll, 100);
      });

      function observeGroups() {
        document.querySelectorAll('[data-mab-marquee]').forEach(function (marquee) {
          var group = marquee.querySelector('[data-mab-group]');
          if (group) groupObserver.observe(group);
        });
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', observeGroups);
      } else {
        observeGroups();
      }

      document.addEventListener('shopify:section:load', observeGroups);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-choose-v1"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function parseStatValue(text) {
      var match = String(text).trim().match(/^([^\d\-]*)([\d,]+(?:\.\d+)?)(.*)$/);
      if (!match) return null;

      var numPart = match[2];
      var decimals = numPart.indexOf('.') > -1 ? numPart.split('.')[1].length : 0;

      return {
        prefix: match[1],
        value: parseFloat(numPart.replace(/,/g, '')),
        suffix: match[3],
        decimals: decimals,
        original: String(text).trim()
      };
    }

    function formatValue(current, parsed) {
      var num;
      if (parsed.decimals > 0) {
        num = current.toFixed(parsed.decimals);
      } else {
        num = Math.round(current).toLocaleString('en-US');
      }
      return parsed.prefix + num + parsed.suffix;
    }

    function animateCounter(el, duration) {
      var raw = el.getAttribute('data-stat-value');
      var parsed = parseStatValue(raw);
      var target = el.querySelector('[data-stat-number]') || el.querySelector('.why-choose-v1__stat-text') || el;

      if (!parsed || isNaN(parsed.value)) {
        target.textContent = raw;
        return;
      }

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        target.textContent = parsed.original;
        return;
      }

      var start = null;

      function frame(timestamp) {
        if (!start) start = timestamp;
        var progress = Math.min((timestamp - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        target.textContent = formatValue(parsed.value * eased, parsed);
        if (progress < 1) {
          requestAnimationFrame(frame);
        } else {
          target.textContent = parsed.original;
        }
      }

      requestAnimationFrame(frame);
    }

    function initWhyChooseV1(root) {
      if (root.getAttribute('data-stat-count') !== 'true') return;

      var duration = parseInt(root.getAttribute('data-stat-duration'), 10) || 2000;
      var counters = root.querySelectorAll('[data-stat-counter]:not([data-stat-counted])');
      if (!counters.length) return;

      if (!('IntersectionObserver' in window)) {
        counters.forEach(function (el) {
          animateCounter(el, duration);
          el.setAttribute('data-stat-counted', 'true');
        });
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          if (el.getAttribute('data-stat-counted')) return;
          el.setAttribute('data-stat-counted', 'true');
          animateCounter(el, duration);
          observer.unobserve(el);
        });
      }, { threshold: 0.35 });

      counters.forEach(function (el) {
        observer.observe(el);
      });
    }

    function initAll() {
      document.querySelectorAll('[data-why-choose-v1]').forEach(initWhyChooseV1);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-why-choose-v1]');
      if (root) initWhyChooseV1(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-choose-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function parseStatValue(text) {
      var match = String(text).trim().match(/^([^\d\-]*)([\d,]+(?:\.\d+)?)(.*)$/);
      if (!match) return null;
      var numPart = match[2];
      var decimals = numPart.indexOf('.') > -1 ? numPart.split('.')[1].length : 0;
      return {
        prefix: match[1],
        value: parseFloat(numPart.replace(/,/g, '')),
        suffix: match[3],
        decimals: decimals,
        original: String(text).trim()
      };
    }

    function formatValue(current, parsed) {
      var num;
      if (parsed.decimals > 0) {
        num = current.toFixed(parsed.decimals);
      } else {
        num = Math.round(current).toLocaleString('en-US');
      }
      return parsed.prefix + num + parsed.suffix;
    }

    function animateCounter(el, duration) {
      var raw = el.getAttribute('data-stat-value');
      var parsed = parseStatValue(raw);
      var target = el.querySelector('[data-stat-number]') || el;
      if (!parsed || isNaN(parsed.value)) {
        target.textContent = raw;
        return;
      }
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        target.textContent = parsed.original;
        return;
      }
      var start = null;
      function frame(timestamp) {
        if (!start) start = timestamp;
        var progress = Math.min((timestamp - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        target.textContent = formatValue(parsed.value * eased, parsed);
        if (progress < 1) requestAnimationFrame(frame);
        else target.textContent = parsed.original;
      }
      requestAnimationFrame(frame);
    }

    function initWhyChooseV2(root) {
      if (root.getAttribute('data-stat-count') !== 'true') return;
      var duration = parseInt(root.getAttribute('data-stat-duration'), 10) || 2000;
      var counters = root.querySelectorAll('[data-stat-counter]:not([data-stat-counted])');
      if (!counters.length) return;
      if (!('IntersectionObserver' in window)) {
        counters.forEach(function (el) {
          animateCounter(el, duration);
          el.setAttribute('data-stat-counted', 'true');
        });
        return;
      }
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          if (el.getAttribute('data-stat-counted')) return;
          el.setAttribute('data-stat-counted', 'true');
          animateCounter(el, duration);
          observer.unobserve(el);
        });
      }, { threshold: 0.35 });
      counters.forEach(function (el) { observer.observe(el); });
    }

    function initAll() {
      document.querySelectorAll('[data-why-choose-v2]').forEach(initWhyChooseV2);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-why-choose-v2]');
      if (root) initWhyChooseV2(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-choose-v3"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function parseStatValue(text) {
      var match = String(text).trim().match(/^([^\d\-]*)([\d,]+(?:\.\d+)?)(.*)$/);
      if (!match) return null;
      var numPart = match[2];
      var decimals = numPart.indexOf('.') > -1 ? numPart.split('.')[1].length : 0;
      return {
        prefix: match[1],
        value: parseFloat(numPart.replace(/,/g, '')),
        suffix: match[3],
        decimals: decimals,
        original: String(text).trim()
      };
    }

    function formatValue(current, parsed) {
      var num = parsed.decimals > 0
        ? current.toFixed(parsed.decimals)
        : Math.round(current).toLocaleString('en-US');
      return parsed.prefix + num + parsed.suffix;
    }

    function animateCounter(el, duration) {
      var raw = el.getAttribute('data-stat-value');
      var parsed = parseStatValue(raw);
      var target = el.querySelector('[data-stat-number]') || el;
      if (!parsed || isNaN(parsed.value)) {
        target.textContent = raw;
        return;
      }
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        target.textContent = parsed.original;
        return;
      }
      var start = null;
      function frame(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        target.textContent = formatValue(parsed.value * eased, parsed);
        if (p < 1) requestAnimationFrame(frame);
        else target.textContent = parsed.original;
      }
      requestAnimationFrame(frame);
    }

    function init(root) {
      if (root.getAttribute('data-stat-count') !== 'true') return;
      var duration = parseInt(root.getAttribute('data-stat-duration'), 10) || 2000;
      var counters = root.querySelectorAll('[data-stat-counter]:not([data-stat-counted])');
      if (!counters.length) return;
      if (!('IntersectionObserver' in window)) {
        counters.forEach(function (el) {
          animateCounter(el, duration);
          el.setAttribute('data-stat-counted', 'true');
        });
        return;
      }
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          if (el.getAttribute('data-stat-counted')) return;
          el.setAttribute('data-stat-counted', 'true');
          animateCounter(el, duration);
          obs.unobserve(el);
        });
      }, { threshold: 0.35 });
      counters.forEach(function (el) { obs.observe(el); });
    }

    function initAll() {
      document.querySelectorAll('[data-why-choose-v3]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[data-why-choose-v3]');
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
